// PreferredDatePicker.js
import React, { memo } from 'react';
import { View, Text, TextInput, Pressable } from 'react-native';
import moment from 'moment';
import TableReservation from '../../Apps/tableReservation/tableReservation';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { formatDate } from '../../js/formatDate';

const PreferredDatePicker = memo(({ preferredDate, onOpenDatePicker, getStyles }) => {

  const { t } = useTranslation();

  const { extraConfigParam } = useSelector((state) => state.deviceConfigSlice);
  const dateFormat = extraConfigParam?.DATE_FORMAT;

  return (
    <View>
      <Text style={getStyles(['guestsText'])}>{t('tableRes.preferred_date')} <Text style={getStyles(['tableReservationStar'])}>*</Text></Text>
      <Pressable onPress={onOpenDatePicker}>
        <View pointerEvents="none">
          <TextInput
            style={getStyles(['textInput'])}
            placeholder="Select your preferred date"
            value={preferredDate ? formatDate(preferredDate, dateFormat) : ""}
            editable={false}
          />
        </View>
      </Pressable>
    </View>
  );
});

export default PreferredDatePicker;
